// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3-Gbd","errorLogs":"styles_errorLogs__3JDga"};